export const mixOf = (_class?: any) => new MixinBuilder(_class);

class MixinBuilder {
	_class: any;
	constructor(_class: any) {
		this._class = _class;
	}

	with(...mixins: any[]) {
		return mixins.reduce((c, mixin) => mixin(c), this._class);
	}
}
